import { render, staticRenderFns } from "./NavegacaoPrincipal.vue?vue&type=template&id=05b2948c&scoped=true&"
import script from "./NavegacaoPrincipal.vue?vue&type=script&lang=js&"
export * from "./NavegacaoPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./NavegacaoPrincipal.vue?vue&type=style&index=0&id=05b2948c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b2948c",
  null
  
)

export default component.exports